import { LOCATION_CHANGE } from 'connected-react-router';
import types from 'config/types/action';

/**
 * Create a Flux Standard Action
 * @param  {string} type action type
 * @param  {object} data data to pass into state
 * @return {object} to be consumed by the reducer
 */
export default function createAction(type, data = null) {
  return { type, payload: data };
}

/**
 * Create a receive secondary content Redux action.
 * @param   {object} content A map of content item related types to content item collections
 * @returns {object}         Redux action
 */
export function actionReceivePrimaryContent(content) {
  return createAction(types.RECEIVE_PRIMARY_CONTENT, content);
}

/**
 * Create a receive primary content Redux action.
 * @param   {object} content A map of content item related types to content item collections
 * @returns {object}         Redux action
 */
export function actionReceiveSecondaryContent(content) {
  return createAction(types.RECEIVE_SECONDARY_CONTENT, content);
}

/**
 * Create a receive error Redux action.
 * @param   {Error}  error
 * @returns {object} Redux action
 */
export function actionReceiveError(error) {
  return createAction(types.RECEIVE_ERROR, error);
}

/**
 * Create a receive site data Redux action.
 * @param   {object}   siteOptions
 * @param   {object[]} siteOptions.menu        map of menu location to menu entities
 * @param   {object[]} siteOptions.info        general site info
 * @param   {object[]} siteOptions.contentType defined content type slugs
 * @param   {object[]} siteOptions.taxonomy    defined taxonomy slugs
 * @param   {object[]} siteOptions.footer      footer data
 * @param   {object[]} siteOptions.redirect    map of paths to redirected to paths
 * @returns {object}                           Redux action
 */
export function actionReceiveSiteOptions(siteOptions) {
  return createAction(types.RECEIVE_SITE_OPTIONS, siteOptions);
}

export function actionRequestContentItem() {
  return createAction(types.REQUEST_CONTENT_ITEM);
}

export function actionRequestArchive() {
  return createAction(types.REQUEST_ARCHIVE);
}

export function actionRequestNextPage() {
  return createAction(types.REQUEST_NEXT_PAGE);
}

export function actionRequestNextPageFetchInitiated() {
  return createAction(types.REQUEST_NEXT_PAGE_FETCH_INITIATED);
}

export function actionRequestSiteOptions() {
  return createAction(types.REQUEST_SITE_OPTIONS);
}

export function actionLocationChange(location) {
  return createAction(LOCATION_CHANGE, location);
}

export function actionQueryAbTester(payload) {
  return createAction(types.QUERY_AB_TESTER, payload);
}

export function fetchUser() {
  return createAction(types.FETCH_USER_REQUESTED);
}

export function actionArticleVideoStarted(payload) {
  return createAction(types.ARTICLE_VIDEO_STARTED, payload);
}

export function actionArticleLinkClicked(payload) {
  return createAction(types.ARTICLE_LINK_CLICKED, payload);
}

export function actionArticleShared(payload) {
  return createAction(types.ARTICLE_SHARED, payload);
}
